import { doesWorkflowRejectCodeExist, getWorkflowRejectCodeMessage } from '@tassat/common-definitions';

import Worker from 'Lib/worker/PrimusWorkerWrapper';

export const validateUsername = async (username: string): Promise<string | null> => {
    try {
        const response = await Worker.getInstance()
            .checkUniqueUsername(username);

        if (response.data && response.data.Status === 48) {
            return null;
        } else if (response.data && response.data.Status === 49) {
            return 'Username is currently in use, please enter a unique username';
        } else if (response.data && doesWorkflowRejectCodeExist(response.data.Status)) {
            return `Could not check username uniqueness: ${getWorkflowRejectCodeMessage(response.data.Status)}`;
        } else {
            return 'Something went wrong when checking username uniqueness. Please contact support';
        }
    } catch (e) {
        return 'Something went wrong when checking username uniqueness. Please contact support';
    }
};